// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"16e3102d","879":"b3213e04"}[chunkId] + ".chunk.js";
};